import { useDesignerStore } from "../store";
import { PRODUCTS, type ProductType } from "../products";

const OPTIONS: { id: ProductType; hint: string; emoji: string }[] = [
  { id: "tshirt", hint: "Print onto a t-shirt", emoji: "👕" },
  { id: "gangsheet", hint: "28 × 100 cm DTF sheet", emoji: "📄" },
];

export default function ProductSelector() {
  const { product, setProduct } = useDesignerStore();

  return (
    <div className="grid grid-cols-2 gap-4">
      {OPTIONS.map((item) => {
        const cfg = PRODUCTS[item.id];
        const active = product === item.id;
        return (
          <button
            key={item.id}
            onClick={() => setProduct(item.id)}
            className={`rounded-xl border p-4 transition text-center ${
              active
                ? "border-cyan-400 bg-cyan-500/20"
                : "border-slate-700 bg-slate-800 hover:bg-slate-700"
            }`}
          >
            {cfg.image ? (
              <img src={cfg.image} className="h-24 mx-auto object-contain" />
            ) : (
              <div className="h-24 mx-auto flex items-center justify-center text-5xl">{item.emoji}</div>
            )}
            <p className="mt-3 text-white font-semibold">{cfg.name}</p>
            <p className="text-slate-400 text-xs mt-1">{item.hint}</p>
          </button>
        );
      })}
    </div>
  );
}
